import { isAuthenticationRequiredSyncError } from '@/lib/sync/error-utils';
import { syncPlayerGroups } from '@/lib/sync/player-groups';
import type { UserId } from '@/schemas/ids';
import { enqueueSyncJob, registerSyncPlugin } from '../plugins.js';
import type { SyncPlugin } from '../plugins.js';

export const PLAYER_GROUPS_SYNC_PLUGIN_KEY = 'player-groups';

const playerGroupsPlugin: SyncPlugin<UserId> = {
  key: PLAYER_GROUPS_SYNC_PLUGIN_KEY,
  createJobKey(userId: UserId) {
    return `player-groups:${String(userId)}`;
  },
  createMetadata(userId: UserId) {
    return {
      entity: 'player-groups',
      scope: String(userId),
      source: 'player-groups-sync-plugin',
    };
  },
  async run(userId: UserId) {
    await syncPlayerGroups(userId);
  },
  shouldRetry(error) {
    return !isAuthenticationRequiredSyncError(error);
  },
};

const registerPlayerGroupsPlugin = registerSyncPlugin as (
  plugin: SyncPlugin<UserId>,
) => SyncPlugin<UserId>;
registerPlayerGroupsPlugin(playerGroupsPlugin);

export function enqueuePlayerGroupsSync(userId: UserId): void {
  const enqueue = enqueueSyncJob as (key: string, scope: UserId) => void;
  enqueue(PLAYER_GROUPS_SYNC_PLUGIN_KEY, userId);
}
